import { Box, Typography } from '@mui/material';
import Block from './Block';
import SavedBlocks from './SavedBlocks';
import { useTranslation } from 'react-i18next';

function BlockPanel() {
    const { t } = useTranslation();

    return (
        <>
            <Typography
                variant="body2"
                fontWeight={500}
                color="textSecondary"
                mb={1}
                textTransform="uppercase"
            >
                {t('Standard Blocks')}
                {/* Content Blocks */}
            </Typography>
            <Box
                display="grid"
                gridTemplateColumns="1fr 1fr 1fr"
                gap={2}
                // padding={1}
                height="max-content"
            >
                <Block type="heading" />
                <Block type="rich-text" />
                <Block type="button" />
                <Block type="divider" />
                <Block type="image" />
                <Block type="spacer" />
                <Block type="file" />
                <Block type="section" />
            </Box>
            <Typography
                variant="body2"
                fontWeight={500}
                color="textSecondary"
                mt={3}
                mb={1}
                textTransform="uppercase"
            >
                {t('Saved Blocks')}
            </Typography>
            <SavedBlocks />
        </>
    );
}

export default BlockPanel;
